// src/components/CategoryListRenderer.jsx
import { useEffect } from "react";
import { createRoot } from "react-dom/client";
import ItemCard from "./SearchModal/ItemCard";

// This component is responsible for rendering the category list of items
const categoryMap = {
 ベーシックパンプス: "item_cards_basic_basic_pumps",
 "形状記憶 スニーカーパンプス": "item_cards_active_memory_foam_insoles_sneaker_pumps",
 "インヒール スニーカーパンプス": "item_cards_active_inheel_sneaker_pumps",
 ウェッジパンプス: "item_cards_active_wedge_pumps",
 しなやかモカシンシューズ: "item_cards_active_flexible_moccasin_shoes",
 ソフトローファー: "item_cards_active_soft_loafers",
 ブーツ: "item_cards_active_boots",
 ニットパンプス: "item_cards_relax_knit_pumps",
 ビットローファー: "item_cards_smart_bit_loafers",
 バレエパンプス: "item_cards_smart_ballet_pumps",
 ウェッジスニーカー: "item_cards_sports_wedge_sneakers",
};

const subcategoryMap = {
 "就活&フレッシャーズ": "item_cards_feature_job_hunting",
};

const seriesMap = {
 スマート: "item_cards_smart",
};

const roots = {};

const CategoryListRenderer = ({ categoryId, subcategoryId, seriesId, items, totalItemsCount }) => {
 useEffect(() => {
  const domNode = document.getElementById(categoryMap[categoryId] || subcategoryMap[subcategoryId] || seriesMap[seriesId]);
  if (domNode) {
   if (!roots[categoryId]) {
    roots[categoryId] = createRoot(domNode);
   }
   roots[categoryId].render(
    <>
     {items.map((item) => (
      <ItemCard key={item.id} props={item} className="--card-category" />
     ))}
    </>
   );

   const matchingCountElement = document.getElementById(`item_matching_count_filtered_${categoryMap[categoryId] || subcategoryMap[subcategoryId] || seriesMap[seriesId]}`);
   const totalItemsCountElement = document.getElementById(`item_matching_count_all_${categoryMap[categoryId] || subcategoryMap[subcategoryId] || seriesMap[seriesId]}`);
   if (matchingCountElement) {
    matchingCountElement.textContent = items.length;
   }
   if (totalItemsCountElement) {
    totalItemsCountElement.textContent = totalItemsCount;
   }
  }
 }, [items, totalItemsCount, categoryId, subcategoryId, seriesId]);

 return null;
};

export default CategoryListRenderer;
